import styles from "../../styles/components/NotificationsModal.module.css";

import Button from "../../ui/buttons/Button";
import IconButton from "../../ui/buttons/IconButton";

import { ReactComponent as MailsIcon } from "../../assets/icons/mails.svg";
import { ReactComponent as LeadsIcon } from "../../assets/icons/leads.svg";
import { ReactComponent as GlassIcon } from "../../assets/icons/glass.svg";
import { ReactComponent as AlertIcon } from "../../assets/icons/alert.svg";
import { ReactComponent as TickIcon } from "../../assets/icons/tick.svg";
import { ReactComponent as WhatsAppIcon } from "../../assets/icons/whatsapp.svg";
import { ReactComponent as BellIcon } from "../../assets/icons/notification.svg";
import { ReactComponent as VectorArrowIcon } from "../../assets/images/vector_arrow.svg";

import {
  formatRelativeTime,
  getContextLabel,
  getSeverity,
  getSeverityLabel,
  getTypeCode,
} from "./notificationsMeta";

const ICONS_BY_TYPE_ICON = {
  mail: MailsIcon,
  leads: LeadsIcon,
  search: GlassIcon,
  alarm: AlertIcon,
  check: TickIcon,
  whatsapp: WhatsAppIcon,
};

const ICON_TONE_CLASS = {
  info: styles.iconInfo,
  success: styles.iconSuccess,
  warning: styles.iconWarning,
  error: styles.iconError,
};

const ROW_TONE_CLASS = {
  warning: styles.rowWarning,
  error: styles.rowError,
};

const SEVERITY_PILL_CLASS = {
  warning: styles.severityPillWarning,
  error: styles.severityPillError,
};

const NotificationRow = ({ notification, onOpen }) => {
  const severity = getSeverity(notification);
  const severityLabel = getSeverityLabel(notification);
  const contextLabel = getContextLabel(notification);
  const isRead = Boolean(notification?.is_read);
  const isChainFinished = getTypeCode(notification) === "mail_chain_finished";
  const Icon = ICONS_BY_TYPE_ICON[notification?.notification_type?.icon] || BellIcon;

  const rowClassName = [
    styles.row,
    isRead ? styles.rowRead : "",
    ROW_TONE_CLASS[severity] || "",
  ]
    .filter(Boolean)
    .join(" ");

  const handleOpen = () => onOpen?.(notification);

  return (
    <div className={rowClassName} onClick={handleOpen}>
      {isRead ? (
        <span className={styles.unreadDotPlaceholder} />
      ) : (
        <span className={styles.unreadDot} role="img" aria-label="No leída" />
      )}

      <div className={`${styles.rowIcon} ${ICON_TONE_CLASS[severity] || ""}`}>
        <Icon aria-hidden="true" focusable="false" />
      </div>

      <div className={styles.rowBody}>
        <div className={styles.rowTopLine}>
          <span className={styles.rowTitle}>{notification?.title}</span>

          {notification?.account_name ? (
            <span className={styles.accountPill}>{notification.account_name}</span>
          ) : null}

          {severityLabel ? (
            <span
              className={`${styles.severityPill} ${SEVERITY_PILL_CLASS[severity] || ""}`}
            >
              {severityLabel}
            </span>
          ) : null}
        </div>

        {contextLabel ? (
          <span className={styles.rowContext}>{contextLabel}</span>
        ) : null}

        {notification?.message ? (
          <div className={styles.rowMessage}>{notification.message}</div>
        ) : null}

        {isChainFinished ? (
          <div className={styles.rowActions}>
            <Button
              variant="secondary"
              tone="blue"
              height={32}
              onClick={(event) => {
                event.stopPropagation();
                handleOpen();
              }}
            >
              Reiniciar comunicación
            </Button>
          </div>
        ) : null}
      </div>

      <div className={styles.rowSide}>
        <span className={styles.rowTime}>
          {formatRelativeTime(notification?.created_at)}
        </span>

        <IconButton
          tone="neutral"
          size="sm"
          icon={<VectorArrowIcon />}
          iconSize={14}
          aria-label="Abrir"
          onClick={(event) => {
            event.stopPropagation();
            handleOpen();
          }}
        />
      </div>
    </div>
  );
};

export default NotificationRow;
